// src/services/categoryServices.js
import { authAxiosInstance } from "../utils/axiosinstance";

// دریافت دسته‌بندی‌های فعال
export const getCategories = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/admin/categories/');
};

// دریافت همه دسته‌بندی‌ها (برای مدیریت)
export const getAllCategories = ({ userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.get('/api/v1/admin/categories/all/');
};

export const createCategory = (data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.post('/api/v1/admin/categories/create/', data);
};

export const updateCategory = (id, data, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.put(`/api/v1/admin/categories/${id}/update/`, data);
};

export const deleteCategory = (id, { userInfo, dispatch }) => {
  const authBackend = authAxiosInstance(userInfo, dispatch);
  return authBackend.delete(`/api/v1/admin/categories/${id}/delete/`);
};